module.exports = __webpack_public_path__ + "img/1_034.a6e2d48a.jpg";